import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import PropTypes from 'prop-types';
import { Column, Row, cls } from '../../packages/components';
import Translator from '../../requests/apa/Translator';
import Assets from '../../requests/apa/Asset';
import {shouldMetadataInfoShowed} from '../../utils/Utils';
import './styles/successSuscription.scss';
import { continuePlay, stopPlayer } from '../../payments/utils/Utils';
import { showSpinner } from '../../utils/Utils';

const getTextByKey = (key) => {
    let txtKey = Translator.get(key) === key ?  key : Translator.get(key);
    txtKey = (txtKey === null || txtKey === ' ') ? '' : txtKey;
    return txtKey;
}

const BodyContent = ({ data }) => {
    const {type = ''} = {} =  data || {};
    const {ticketPriceTax= {}, ticketBonus = {}} = data || {};
    const metadataPriceTax = {}, metadataBonus = {};

    if (shouldMetadataInfoShowed()){
        metadataPriceTax['data-metadata-key'] = ticketPriceTax.key;
        metadataBonus['data-metadata-key'] = ticketBonus.key;
    }

    return (
        <Row className="aaf-modal-success-suscrription aaf-modal-bottom">
            <Column lg={6} className="aaf-modal-image-large">
                <img src={data.img_large} alt="img_large" />
            </Column>
            <Column lg={6}>
                <Row className="aaf-modal-success-info">
                    {data.providerImage && (
                        <div>
                        <Column lg={5} className={'aaf-modal-logo-provider'}>
                            <img src={data.providerImage} alt="logo" />
                        </Column>
                        <Column lg={2} className={'aaf-modal-logo-provider-success'}>
                            <img src={Assets.get(`ticket_subscription_icon_confirm`)} alt="Check_logo" />
                        </Column>
                        </div>
                    )}
                    {data.contentTitle && (
                        <Column lg={12}>
                            <Column lg={10} className={'aaf-modal-contentTitle'}>
                                {`${data.contentTitle}`}
                            </Column>
                            <Column lg={2} className={'aaf-modal-contentTitle-image'}>
                                <img src={Assets.get(`ticket_subscription_icon_confirm`)} alt="Check_logo" />
                            </Column>
                        </Column>
                    )}
                    {data.title && (
                        <Column lg={12}>
                            <span className="aaf-modal-title">{data.title}</span>
                        </Column>
                    )}
                    {ticketBonus.label && (
                        <Column lg={12}>
                            <span {...metadataBonus} className="aaf-modal-color-info">{ticketBonus.label}</span>
                        </Column>
                    )}
                    {data.content && (
                        <Column lg={12}>
                            <span>{data.content}</span>
                        </Column>
                    )}
                </Row>
                <Row className="aaf-modal-success-pay">
                    {ticketPriceTax.label && <Column lg={12} className={cls('ticket_subscription_total_total_div')}>
                        <span {...metadataPriceTax}>{`${getTextByKey('Transaccionales_Ticket_TextoTotal')}`}</span>
                        <span className='ticket_subscription_total-amount'>{` ${ticketPriceTax.label}`}</span>
                    </Column>}                    
                    {data.labelPaymentMethod && <Column lg={12} className={'ticket_subscription_total_paymentMethod_div'}>
                        <span>{`${getTextByKey('Transaccionales_Ticket_TextoMedioDePago1')}`}</span>                        
                    </Column>
                    }
                    {data.payment_method && <Column lg={12}>
                                                <span className='ticket_subscription_paymentMethod_data'> {`${data.labelPaymentMethod || ''} `}</span>
                                                <span className='ticket_subscription_paymentMethod_account'>{`${data.payment_method}`}</span>
                                            </Column>
                    }
                    {data.next_pay && (
                        <Column lg={10} className={'ticket_subscription_total_validity_div'}>
                            <span>{`${getTextByKey('Transaccionales_Ticket_TextoVigencia')}`}</span>
                            <span className={'ticket_subscription_total_validity_data'}>{` ${data.next_pay}`}</span>
                            {type && type === 'rent' &&
                                <span className={'ticket_subscription_total_validity_data_text'}> {` ${getTextByKey('ticket_subscription_sufixDurationRent_label')}`}  </span>
                            }
                        </Column>
                    )}
                </Row>
            </Column>
        </Row>
    );
};

const AAFModalSuccessSuscription = (props = {}) => {
    const title = getTextByKey('ticket_subscription_title');
    const buttons = [];

    // payment methods experience is passed as a prop from the caller (Checkout)
    const pmExp = props.payment_methods_experience;

    if (props.data.from) {
        buttons.push({
            content: getTextByKey('ticket_subscription_option_button_next'),
            props: {
                onClick: (e) => {
                    props.data && props.data.is2FA && stopPlayer(); 
                    setTimeout(() => {
                    props.handlePlay && typeof props.handlePlay === 'function' && props.handlePlay(e, props.callback);
                    props.handleClose(e, props.callback);
                    }, 500);
                },
                className: pmExp ? 'new-button-container' : 'button-container',
                variant: pmExp ? 'gray' : 'primary'
            },
        });
    } else {
        //Flujo para contenido live
        if (props.data.groupId || props.data.islive) {
            buttons.push({
                content: getTextByKey('Transaccionales_Ticket_TextoBotonPrimarioReproducir'),
                props: {
                    onClick: (e) => {
                        showSpinner(true);
                        props.data && props.data.is2FA && stopPlayer(); 
                        setTimeout(() => {
                        props.handlePlay && typeof props.handlePlay === 'function' && props.handlePlay(e, props.callback);
                        props.handleClose(e, props.callback);
                        }, 500);
                    },
                    className: pmExp ? 'new-button-container' : 'button-container',
                    variant: pmExp ? 'gray' : 'primary'
                },
            });
        
            buttons.push({
                content: getTextByKey('Transaccionales_Ticket_TextoBotonSecundarioCerrar'),
                props: {
                    onClick: (e) => {
                        if (props.data && !props.data.is2FA) {
                            props.handleVCard && typeof props.handleVCard === 'function' && props.handleVCard(e, props.callback);
                        }
                        props.handleClose(e, props.callback);
                        props.data && props.data.is2FA && continuePlay();
                    },
                    className: pmExp ? 'new-button-container' : 'button-container',
                    variant: pmExp ? 'gray' : 'dark'
                },
            });
        } else {
            //Flujo para contenido VOD
            buttons.push({
                content:  getTextByKey('Transaccionales_Ticket_TextoBotonPrimarioReproducir'),
                props: {
                    onClick: (e) => {
                        showSpinner(true);
                        props.data && props.data.is2FA && stopPlayer(); 
                        setTimeout(() => {
                        props.handlePlay && typeof props.handlePlay === 'function' && props.handlePlay(e, props.callback);
                        props.handleClose(e, props.callback);
                        }, 500);
                    },
                    className: pmExp ? 'new-button-container' : 'button-container',
                    variant: pmExp ? 'gray' : 'primary'
                },
            });
        
            buttons.push({
                content: getTextByKey('Transaccionales_Ticket_TextoBotonSecundarioCerrar'),
                props: {
                    onClick: (e) => {
                        if (props.data && !props.data.is2FA) {
                            props.handleVCard && typeof props.handleVCard === 'function' && props.handleVCard(e, props.callback);
                        }
                        props.handleClose(e, props.callback);
                        props.data && props.data.is2FA && continuePlay();
                    },
                    className: pmExp ? 'new-button-container' : 'button-container',
                    variant: pmExp ? 'gray' : 'dark'
                },
            });
        }
    }

    const p = {
        title,
        alwaysEnabled: true,
        buttons,
        aafNewStyle: true,
        className: 'aaf-modal aaf-modal--success-suscription',
        showLogo: false,
        buttonsAlign: 'vertical',
        backclose: true,
    };
    return (
        <ModalWrapper {...p}>
            <BodyContent data={props.data} />
        </ModalWrapper>
    );
};

AAFModalSuccessSuscription.propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
    payment_methods_experience: PropTypes.bool
};

export default withOnClose(AAFModalSuccessSuscription);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalSuccessSuscription.jsx